<template>
    <el-popover
        ref="letter-view"
        placement="top"
        title=""
        width="760"
        trigger="manual"
        v-model="showLetterForm"
        :visible-arrow="false"
        popper-class="event-letter-view"
        v-on-clickaway="hideLetterForm"
    >
        <el-row class="mb10">
            <el-col :span="2" class="label">
                От кого:
            </el-col>
            <el-col :span="22" class="title">
                {{ sender }}
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col :span="2" class="label">
                Кому:
            </el-col>
            <el-col :span="22" class="title">
                {{ receiver }}
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col :span="2" class="label">
                Копия:
            </el-col>
            <el-col :span="22" class="title">
                {{ event.data.letter.copy }}
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col :span="2" class="label">
                Тема:
            </el-col>
            <el-col :span="22" class="bold title">
                {{ event.data.letter.subject }}
            </el-col>
        </el-row>
        <el-row class="mb16">
            <el-col class="title">
                <div v-format-text="event.data.extraText"></div>
            </el-col>
        </el-row>
        <el-row>
            <!--<el-col :span="1">
                <div class="event-icon-reply-orange"></div>
            </el-col>-->
            <el-col :span="1" v-if="isAttachmentExist">
                <div class="event-icon-attachment-orange"></div>
            </el-col>
        </el-row>
        <el-row v-if="isAttachmentExist">
            <el-col :span="22" :offset="1" class="event-attachments">
                <el-tag
                    v-for="file in event.data.attachments"
                    :key="file.name"
                    :type="''"
                    size="mini"
                    :disable-transitions="true"
                >
                    <span class="event-icon-download-orange" @click="getAttachment(file)"></span>
                    <span>{{ file.name }}</span>
                </el-tag>
            </el-col>
        </el-row>
    </el-popover>
</template>

<script>
import '@/assets/styles/events.scss';
import { mixin as clickaway } from 'vue-clickaway';
import FileSaver from 'file-saver';

export default {
    name: 'EventLetter',
    mixins: [
        clickaway
    ],
    data() {
        return {
            showLetterForm: false
        };
    },
    props: {
        event: {
            type: Object,
            default: () => {
                return {
                    data: {}
                };
            }
        },
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAttachmentExist() {
            return this.event.data.attachments && this.event.data.attachments.length;
        },
        sender() {
            if (this.event && this.event.data && this.event.data.initiator) {
                if (this.event.data.initiator.type === 'employer') {
                    return `${this.event.data.initiator.info.title} <${this.event.data.initiator.info.email}>`;
                }
                if (this.event.data.initiator.type === 'other') {
                    if (this.event.data.initiator.info.title) {
                        return `${this.event.data.initiator.info.title}`;
                    }
                    return `${this.event.data.employerLink.title}`;
                }
            }
            return '';
        },
        receiver() {
            if (this.event && this.event.data) {
                if (this.event.data.readEmail) {
                    return `<${this.event.data.readEmail}>`;
                }
                if (this.event.data.contactLink && Object.prototype.hasOwnProperty.call(this.event.data.contactLink, 'email')) {
                    return `${this.event.data.contactLink.title} <${this.event.data.contactLink.email}>`;
                }
                if (this.event.data.employerLink && Object.prototype.hasOwnProperty.call(this.event.data.employerLink, 'email')) {
                    return `${this.event.data.employerLink.title} <${this.event.data.employerLink.email}>`;
                }
            }
            return '';
        }
    },
    methods: {
        hideLetterForm(event) {
            if (!event.target.classList.contains('event-link') && this.showLetterForm) {
                this.showLetterForm = false;
                this.$emit('changeVisibility', false);
            }
        },
        async getAttachment(file) {
            try {
                const response = await this.$store.dispatch('events/getAttachment', file.filename);
                FileSaver(new Blob([response.data], { type: file.type }), file.name);
            } catch (e) {
                console.log(e);
            }
        }
    },
    watch: {
        isVisible(value) {
            this.showLetterForm = value;
        }
    }
};
</script>
